import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    const el = this.iconTarget
    el.classList.add("like-pop")
    el.addEventListener("animationend", () => el.classList.remove("like-pop"), { once: true })
  }
}
